import {Component, Inject, OnInit, Renderer2} from '@angular/core';
import {DOCUMENT} from '@angular/common';
import {Router} from '@angular/router';
import {LoginService} from '@core/services';
import {Account} from '@core/bo';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ChangePasswordDialogComponent} from './change-password-dialog/change-password-dialog.component';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
})
export class NavbarComponent implements OnInit {
    admin: Account;

    constructor(
        @Inject(DOCUMENT) private document: Document,
        private renderer: Renderer2,
        private router: Router,
        private loginService: LoginService,
        private modalService: NgbModal
    ) {
    }

    ngOnInit(): void {
        this.loginService.getAdmin().subscribe(admin => {
            this.admin = admin;
        });
    }

    /**
     * Sidebar toggle on hamburger button click
     */
    toggleSidebar(e) {
        e.preventDefault();
        this.document.body.classList.toggle('sidebar-open');
    }

    /** Mở hộp thoại tự đổi mật khẩu ĐĂNG NHẬP HRM. */
    onChangePassword(e) {
        e.preventDefault();
        this.modalService.open(ChangePasswordDialogComponent, {size: 'lg', backdrop: 'static'});
    }

    /**
     * Logout
     */
    onLogout(e) {
        e.preventDefault();
        this.loginService.logout().subscribe(data => {
            this.router.navigateByUrl('/auth/login');
        });
    }

}
